export const TESTIMONIAL_BULLET_AVATAR_SIZE = 48;
